export {
  default as PayerNameComponent,
  renderPayerNameComponent,
} from './PayerNameComponent';
export * from './config';
